var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',[_c('div',{staticClass:"modal--mask"},[_c('div',{staticClass:"modal--wrapper"},[_c('div',{staticClass:"loader"})])])])}
var staticRenderFns = []

export { render, staticRenderFns }